<app-pcbread-crumb [data]="'Administration,BasicData,Doctor'"></app-pcbread-crumb>
<app-pccrud [endPoint]="'Doctor'" ></app-pccrud>
